import React, { useState, useRef, useEffect } from 'react';
import Simple from './transcriptsimple';
import Picking from '../google-drive-implementation/picker';



const Registro = () => {
  const [procedurResponse, setProcedureResponse] = useState(''); // Add a new state variable for the chat response
  const [chatResponse2, setchatResponse2] = useState('');
  
  

 
  

  return (
    <div >
      <h1>Registro Médico</h1>
                        <Simple chatResponse2={chatResponse2} 
                                setchatResponse2={setchatResponse2} 
                                procedurResponse={procedurResponse}
                                setProcedureResponse={setProcedureResponse}/>
                                
    <Picking />
   
</div>
      
      
    
  );
};

export default Registro;
